import React, {FC} from "react"
import {omit} from "lodash"

import id from "@irati/utils/id"
import {IconProps} from "@irati/ui/src/Icon"

import {Icon, ButtonRouterLink} from "./styled"
import Flex from "../../../Flex"

interface Props extends IconProps {
  id?: string
}

const IconButtonRouterLink: FC<Props> = (props) => {
  const idNamespace = id("IconButtonRouterLink", props)
  const {children} = props
  const iconProps = omit(props, ["onClick", "className"])

  return (
    <ButtonRouterLink id={idNamespace} {...props}>
      <Flex alignItems="center">
        <Icon size={14} hasChildren={!!children} {...iconProps} />
        {children}
      </Flex>
    </ButtonRouterLink>
  )
}

export default IconButtonRouterLink
